import { ConfirmModalProps as BlublocksConfirmModalProps } from "@bluframe/blublocks"
import { memo } from "react"

import ConfirmModal from "./ConfirmModal"

export interface Props extends BlublocksConfirmModalProps {
  title?: string
  isConfirmDisabled?: boolean
}

export interface ComponentProps extends Props {}

export default memo(ConfirmModal)
